<template>
  <div class="bg-secondary-subtle rounded px-2.5 py-1.5 border border-secondary-alt/20">
    <slot />
  </div>
</template>

<script setup>

</script>
